"use client"

import styled from "@emotion/styled"
import type { PropsWithChildren } from "react"

const MasterProjectTheme = styled.div`
  --master-light: rgb(201, 233, 237);
  background-color: #131f34;
  color: var(--master-light);
  min-height: 100vh;

  &[data-master-project] * {
    color: var(--master-light) !important;
  }

  &[data-master-project] [data-master-hero] section {
    background-color: #131f34;
  }

  &[data-master-project] [data-master-hero] section > div > div:first-of-type::before {
    background-color: #131f34 !important;
  }

  &[data-master-project] [data-master-hero] section > div > div:nth-of-type(2) {
    background-color: #131f34;
  }

  &[data-master-project] [data-master-hero] h1 strong::before {
    background-color: #131f34 !important;
  }

  &[data-master-project] [data-master-topbanner] {
    padding: 40px 20px;
  }

  &[data-master-project] > [data-master-topbanner]:first-child {
    padding-top: 0;
    padding-bottom: 0;
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    &[data-master-project] [data-master-topbanner] {
      padding: 60px 32px;
    }

    &[data-master-project] > [data-master-topbanner]:first-child {
      padding-top: 0;
    }
  }

  &[data-master-project] [data-master-faq] section,
  &[data-master-project] [data-master-faq] [class*="FaqNew-StyledSlideContainer"] {
    background-color: #131f34;
  }

  &[data-master-project] [data-master-faq] ul,
  &[data-master-project] [data-master-faq] li,
  &[data-master-project] [data-master-faq] li > div,
  &[data-master-project] [data-master-faq] li > div > div {
    background-color: #131f34 !important;
  }

  &[data-master-project] [data-master-faq] [role="button"] {
    border-color: rgba(201, 233, 237, 0.2) !important;
  }

  &[data-master-project] [data-master-faq] li,
  &[data-master-project] [data-master-faq] [class*="MuiAccordion-root"] {
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28) !important;
  }

  &[data-master-project] [data-master-faq] [class*="MuiAccordion"],
  &[data-master-project] [data-master-faq] [class*="MuiPaper"],
  &[data-master-project] [data-master-faq] [class*="MuiCollapse"],
  &[data-master-project] [data-master-faq] [class*="MuiAccordionSummary"],
  &[data-master-project] [data-master-faq] [class*="MuiAccordionDetails"],
  &[data-master-project] [data-master-faq] [class*="MuiTypography"],
  &[data-master-project] [data-master-faq] p,
  &[data-master-project] [data-master-faq] h3,
  &[data-master-project] [data-master-faq] h4,
  &[data-master-project] [data-master-faq] h5,
  &[data-master-project] [data-master-faq] h6,
  &[data-master-project] [data-master-faq] li {
    color: var(--master-light) !important;
    background-color: #131f34 !important;
  }

  &[data-master-project] [data-master-faq] [class*="MuiPaper"]::before,
  &[data-master-project] [data-master-faq] [class*="MuiAccordion"]::before,
  &[data-master-project] [data-master-faq] [class*="MuiAccordion"]::after,
  &[data-master-project] [data-master-faq] [class*="MuiAccordion"]:before,
  &[data-master-project] [data-master-faq] [class*="MuiAccordion"]:after {
    background-color: #131f34 !important;
    opacity: 1 !important;
  }

  &[data-master-project] [data-master-faq] button,
  &[data-master-project] [data-master-faq] button div::before,
  &[data-master-project] [data-master-faq] button div::after {
    color: var(--master-light) !important;
    background-color: var(--master-light) !important;
  }

  &[data-master-project] button {
    color: var(--master-light) !important;
    border-color: var(--master-light) !important;
  }

  &[data-master-project] svg {
    fill: currentColor;
  }
`

type Props = PropsWithChildren<{
  className?: string
}>

const MasterProjectThemeWrapper = ({ children, className }: Props) => {
  return (
    <MasterProjectTheme data-master-project className={className}>
      {children}
    </MasterProjectTheme>
  )
}

export default MasterProjectThemeWrapper
